import { useEffect, useState } from 'react';
import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';

export interface ArtistHit {
  musicapiArtistId: number;
  name: string;
  imageUrl: string | null;
  followers: number | null;
}

const DEBOUNCE_MS = 250;

/** "Who do you sound like?" (frame b3): the artist index search, 250 ms after the last key. */
export function useArtistSearch(text: string) {
  const trpcAPI = useTRPCAPI();
  const [q, setQ] = useState('');
  useEffect(() => {
    const timer = setTimeout(() => setQ(text.trim()), DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [text]);
  const query = useTRPCQuery(
    trpcAPI.outreach.profile.searchArtists.queryOptions({ q }, { enabled: q.length > 0, retry: false })
  );
  return { hits: (query.data as ArtistHit[] | undefined) ?? [], isLoading: query.isFetching && q.length > 0 };
}
